import { ServiceRequestSendEmailCardTask } from '../common/tasks/ServiceRequestSendEmailCardTask';
import { ApproveCompanyDetails } from './components/ApproveCompanyDetails';
import { FillCompanyDetails } from './components/FillCompanyDetails';
import { IncorporationDetails } from './components/IncorporationDetails';
import { MarkAsFiledComponent } from './components/MarkAsFiled';
import { UploadIncorporationDocuments } from './components/UploadIncorporationDocuments';
import { CaCorpIncorporationTask } from './config';

export const CA_CORP_INCORPORATION_COMPONENT_MAP = {
  // Company Formation Details
  [CaCorpIncorporationTask.FILL_CORPORATION_DETAILS]: FillCompanyDetails,
  [CaCorpIncorporationTask.REVIEW_CORPORATION_DETAILS]: ApproveCompanyDetails,

  // Incorporation Filing
  [CaCorpIncorporationTask.FILE_INCORPORATION]: MarkAsFiledComponent,
  [CaCorpIncorporationTask.UPLOAD_INCORPORATION_DOCUMENTS]:
    UploadIncorporationDocuments,
  [CaCorpIncorporationTask.FILL_INCORPORATION_DETAILS]: IncorporationDetails,
  [CaCorpIncorporationTask.SEND_EMAIL_UPDATE]: ServiceRequestSendEmailCardTask,
};
